// src/components/ProtectedRoute.jsx
import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { logout } from "../utils/helpers";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const loggedInUser = useSelector((state) => state.auth.user);

  // Check if token or user is missing or invalid
  const isAuthenticated = loggedInUser;

  useEffect(() => {
    if (!isAuthenticated) {
      logout(); // clear any stale tokens
    }
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    // Redirect to login and preserve attempted URL
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
};

export default ProtectedRoute;
